import {PageEvent} from '@spartacus/storefront';

export class CheckoutReviewOrderPageEvent extends PageEvent {}
